import * as React from 'react';
import * as classNames from 'classnames/bind';
import { Link } from 'react-static';

import styles from './Nav.scss';

export interface NavLinkProps {
  isOpened: boolean;
  closeMenu?: () => void;
  toggleSubMenu: (SubMenuParent: string, mobileMenu: boolean) => void;
  closeSubMenu: (e: React.FocusEvent<{}>) => void;
  item: {
    href: string;
    text: string;
    submenu?: {
      href: string;
      text: string;
    }[];
  };
}

const cx = classNames.bind(styles);

const NavLink: React.SFC<NavLinkProps> = ({
  item,
  isOpened,
  closeMenu,
  toggleSubMenu,
  closeSubMenu,
}) => {
  const className = cx({
    isOpened,
    itemContainer: true,
  });

  const linkClassName = cx({
    link: true,
    'd-none d-lg-inline-flex': item.submenu !== undefined,
  });

  return (
    <div className={className}>
      {!item.submenu ? (
        <Link
          to={item.href}
          className={linkClassName}
          activeClassName={styles.activeLink}
          onFocus={() => toggleSubMenu(item.href, false)}
          onBlur={closeSubMenu}
          onClick={closeMenu}
        >
          {item.text}
          {item.submenu && <span className={styles.plusSymbol} />}
        </Link>
      ) : (
        <>
          <button
            tabIndex={0}
            className={styles.link}
            onClick={() => toggleSubMenu(item.href, true)}
          >
            {item.text}
            <span className={styles.plusSymbol} />
          </button>
          <div className={styles.submenuContainer}>
            {item.submenu.map((submenuItem, index) => (
              <Link
                key={index}
                to={submenuItem.href}
                tabIndex={isOpened ? 0 : -1}
                className={styles.submenuLink}
                activeClassName={styles.activeSubMenuLink}
                onClick={closeMenu}
              >
                {submenuItem.text}
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default NavLink;



// WEBPACK FOOTER //
// /www/client/src/components/Nav/NavLink.tsx